export const addSlideInViewAtrribute = (emblaApi) => {
  const slideNodes = emblaApi.slideNodes();
  const slidesInView = emblaApi.slidesInView();

  slideNodes.forEach((element, index) => {
    slidesInView.includes(index)
      ? element.setAttribute('data-slide-in-view', '')
      : element.removeAttribute('data-slide-in-view');
  });
};
